import { random } from "@/shared/utils/random";
import CryptoJS from "crypto-js";

/**
 * Генерирует случайную строку для Code-Verifier
 * Code-Verifier: строка длиной 43-128 символов из допустимых символов
 */
function generateCodeVerifier(): string {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const length = random(60, 128);
  let verifier = "";

  for (let i = 0; i < length; i++) {
    verifier += characters.charAt(random(0, characters.length - 1));
  }

  return verifier;
}

/**
 * Преобразует строку в Base64URL формат
 */
// function toBase64Url(str: string): string {
//   return str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
// }

/**
 * Генерирует Code-Challenge из Code-Verifier используя SHA-256
 */
function generateCodeChallenge(codeVerifier: string): string {
  try {
    // Используем crypto-js для SHA-256 хеширования (работает везде)
    const hash = CryptoJS.SHA256(codeVerifier).toString(CryptoJS.enc.Hex);
    return hash;
  } catch (error) {
    console.error("Error generating code challenge:", error);
    throw new Error("Failed to generate code challenge");
  }
}

/**
 * Генерирует пару Code-Verifier и Code-Challenge
 */
export function generatePKCEPair(): {
  codeVerifier: string;
  codeChallenge: string;
} {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = generateCodeChallenge(codeVerifier);
  return {
    codeVerifier,
    codeChallenge,
  };
}
